import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "DELETE_MANY_CARRIER_RESPONSIBLE_EMAIL_" }
);

export interface DeleteManyCarrierResponsibleEmailState extends IState {}

const INITIAL_STATE: DeleteManyCarrierResponsibleEmailState = {
  loading: false,
  error: null,
};

const request = (state: DeleteManyCarrierResponsibleEmailState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: DeleteManyCarrierResponsibleEmailState,
  action: ISuccessAction
) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (
  state: DeleteManyCarrierResponsibleEmailState,
  action: IFailureAction
) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const deleteManyCarrierResponsibleEmail = createReducer(
  INITIAL_STATE,
  {
    [Types.REQUEST]: request,
    [Types.SUCCESS]: success,
    [Types.FAILURE]: failure,
    [Types.RESET]: reset,
  }
);

export const DeleteManyCarrierResponsibleEmailTypes = Types;
export const DeleteManyCarrierResponsibleEmailActions = Creators;
